import { BankAccount, PaymentMethod, StripePaymentMethod, WirePaymentMethod } from 'types/payment';

export const isBankPaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is BankAccount => {
	return paymentMethod.hasOwnProperty('routingNumber');
};

export const isStripePaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is StripePaymentMethod => {
	return paymentMethod.hasOwnProperty('stripePaymentMethodId');
};

export const isWirePaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is WirePaymentMethod => {
	return paymentMethod.hasOwnProperty('wirePaymentMethodId');
};
